// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  "sweden" : {
  hmr: true,
  enableMock: false, // true for mock; else false
  useProxy: false, // true for mock; else false
  mockUrl: "http://localhost:3000",
  apiUrl: "https://i1uipzq935.execute-api.eu-north-1.amazonaws.com/divr-dev", // API URL - DNB Dev
  // https://i1uipzq935.execute-api.eu-north-1.amazonaws.com/divr-dev/ivr/getEnglishChannelMap?userType=Business
  // apiUrl: "https://m2ydq5e7ch.execute-api.us-east-1.amazonaws.com/divr-dev", // API URL - CTS Dev
  oktaUrl: "https://qa.sso.dnb.com/oauth2/ausg86rerPKZ500yO1d6/v1", // Okta URL - QA
  oktaClientId: "0oahk097iVUKMc7kX1d6", // Okta client ID - QA
  version: "<<VERSION>>",
  googleAnalyticsKey:"",
  redirectUrlInternalUser: "https://fcs-dnbus.cs9.force.com/support/?Origin=DIVR",
  ipUrl: "https://ipapi.co/json/",
  driftAccount: "tt96hwidbxxb",
  // driftPlaybook: 389219,
  swedishDriftPlaybook: 396137,
  swedishEnglishDriftPlaybook: 390363,
  driftCaseOrigin: "Chat (Digital IVR)",
  loginFailureScenario: "https://fcs-dnbus.cs9.force.com/support/?prod=sso&origin=divr",
  cgClientId: '7189sbl23q514ilj581ot2c6co', //Customer Gauge Client-Id
  cgClientSecret: '6fasnl06884o2r17cvdbnvqtukp8hc51cfd7pc1jijpnlsu1s0h', //Customer Gauge Client-Secret
  cgTokenUrl: 'https://auth.eu.customergauge.com/oauth2/token',
  cgFeedbackUrl: 'https://imports.api.eu.customergauge.com',
  cgEmail: "dev-divrtechsupport@dnb.com",
  title: "Sweden Digital Service Center: support for all things Dun & Bradstreet",
  metaDescription: 'Sweden Customer service portal for D&B solutions/services. Request a D-U-N-S Number, update your company information, get product help, access live support options.'
  },
  "norway" : {
  hmr: true,
  enableMock: false, // true for mock; else false
  useProxy: false, // true for mock; else false
  mockUrl: "http://localhost:3000",
  apiUrl: "https://0hvvv2qpg5.execute-api.eu-north-1.amazonaws.com/divr-dev", // API URL - DNB Dev
  // https://i1uipzq935.execute-api.eu-north-1.amazonaws.com/divr-dev/ivr/getEnglishChannelMap?userType=Business
  // apiUrl: "https://m2ydq5e7ch.execute-api.us-east-1.amazonaws.com/divr-dev", // API URL - CTS Dev
  oktaUrl: "https://qa.sso.dnb.com/oauth2/ausg86rerPKZ500yO1d6/v1", // Okta URL - QA
  oktaClientId: "0oahk097iVUKMc7kX1d6", // Okta client ID - QA
  version: "<<VERSION>>",
  googleAnalyticsKey:"",
  redirectUrlInternalUser: "https://fcs-dnbus.cs9.force.com/support/?Origin=DIVR",
  ipUrl: "https://ipapi.co/json/",
  driftAccount: "tt96hwidbxxb",
  // driftPlaybook: 389219,
  norwegianDriftPlaybook: 307548,
  norwegianEnglishDriftPlaybook: 307548,
  driftCaseOrigin: "Chat (Digital IVR)",
  loginFailureScenario: "https://fcs-dnbus.cs9.force.com/support/?prod=sso&origin=divr",
  cgClientId: '7189sbl23q514ilj581ot2c6co', //Customer Gauge Client-Id
  cgClientSecret: '6fasnl06884o2r17cvdbnvqtukp8hc51cfd7pc1jijpnlsu1s0h', //Customer Gauge Client-Secret
  cgTokenUrl: 'https://auth.eu.customergauge.com/oauth2/token',
  cgFeedbackUrl: 'https://imports.api.eu.customergauge.com',
  cgEmail: "dev-divrtechsupport@dnb.com",
  title: "Norway Digital Service Center: support for all things Dun & Bradstreet",
  metaDescription: 'Norway Customer service portal for D&B solutions/services. Request a D-U-N-S Number, update your company information, get product help, access live support options.'

  },
  "germany" : {
    hmr: true,
    enableMock: false, // true for mock; else false
    useProxy: false, // true for mock; else false
    mockUrl: "http://localhost:3000",
    apiUrl: "https://iq4jzmftbk.execute-api.eu-north-1.amazonaws.com/divr-dev"  ,
    oktaUrl: "https://sso.dnb.com/oauth2/ausjte6yg4e6fzj4K5d6/v1", // production
    oktaClientId: "0oako8oc0z5jiBsoe5d6", // Okta client ID
    version: "<<VERSION>>",
    googleAnalyticsKey:"",
    redirectUrlInternalUser: "https://support.dnb.com/?Origin=DIVR",
    ipUrl: "https://ipapi.co/json/",
    driftAccount: "nugs43psmi2s",
    // driftPlaybook: 389219,
    germanDriftPlaybook: 391587,
    germanEnglishDriftPlaybook: 391587,
    driftCaseOrigin: "Chat (Digital IVR)",
    loginFailureScenario: "https://support.dnb.com/?prod=sso&origin=divr",
    cgEmail: "divrtechsupport@dnb.com",
    title: "Germany Digital Service Center: support for all things Dun & Bradstreet",
    metaDescription: 'Germany Customer service portal for D&B solutions/services. Request a D-U-N-S Number, update your company information, get product help, access live support options.'
  },
  "finland" : {
    hmr: true,
    enableMock: false, // true for mock; else false
    useProxy: false, // true for mock; else false
    mockUrl: "http://localhost:3000",
    apiUrl: "https://cqdq6b30hi.execute-api.eu-north-1.amazonaws.com/divr-dev/", // production
    oktaUrl: "https://sso.dnb.com/oauth2/ausjte6yg4e6fzj4K5d6/v1", // production
    oktaClientId: "0oako8oc0z5jiBsoe5d6", // Okta client ID
    version: "<<VERSION>>",
    googleAnalyticsKey:"",
    redirectUrlInternalUser: "https://support.dnb.com/?Origin=DIVR",
    ipUrl: "https://ipapi.co/json/",
    driftAccount: "tt96hwidbxxb",
    // driftPlaybook: 389219,
    finlandDriftPlaybook: 312957,
    finlandEnglishDriftPlaybook: 312957,
    driftCaseOrigin: "Chat (Digital IVR)",
    loginFailureScenario: "https://support.dnb.com/?prod=sso&origin=divr",
    cgEmail: "divrtechsupport@dnb.com",
    title: "Finland Digital Service Center: support for all things Dun & Bradstreet",
    metaDescription: 'Finland Customer service portal for D&B solutions/services. Request a D-U-N-S Number, update your company information, get product help, access live support options.'
  },
  "denmark" : {
    hmr: true,
    enableMock: false, // true for mock; else false
    useProxy: false, // true for mock; else false
    mockUrl: "http://localhost:3000",
    apiUrl: "https://cilcsvtppa.execute-api.eu-north-1.amazonaws.com/divr-dev/", // dev
    oktaUrl: "https://sso.dnb.com/oauth2/ausjte6yg4e6fzj4K5d6/v1", // dev
    oktaClientId: "0oako8oc0z5jiBsoe5d6", // Okta client ID
    version: "<<VERSION>>",
    googleAnalyticsKey:"",
    redirectUrlInternalUser: "https://support.dnb.com/?Origin=DIVR",
    ipUrl: "https://ipapi.co/json/",
    driftAccount: "tt96hwidbxxb",
    // driftPlaybook: 389219,
    denmarkDriftPlaybook: 280221,
    denmarkEnglishDriftPlaybook: 280221,
    driftCaseOrigin: "Chat (Digital IVR)",
    loginFailureScenario: "https://support.dnb.com/?prod=sso&origin=divr",
    cgEmail: "divrtechsupport@dnb.com",
    title: "Denmark Digital Service Center: support for all things Dun & Bradstreet",
    metaDescription: 'Denmark Customer service portal for D&B solutions/services. Request a D-U-N-S Number, update your company information, get product help, access live support options.'
  },
  "us" : {
  hmr: true,
  enableMock: false, // true for mock; else false
  useProxy: false, // true for mock; else false
  mockUrl: "http://localhost:3000",
  apiUrl: "https://api.dev-service.dnb.com", // API URL - DNB Dev
  iDaaSUrl: "https://api.idaas.dnb.com",
  // apiUrl: "https://m2ydq5e7ch.execute-api.us-east-1.amazonaws.com/divr-dev", // API URL - CTS Dev
  oktaUrl: "https://qa.sso.dnb.com/oauth2/ausg86rerPKZ500yO1d6/v1", // Okta URL - QA
  oktaClientId: "0oahk097iVUKMc7kX1d6", // Okta client ID - QA
  version: "<<VERSION>>",
  googleAnalyticsKey:"266853667",
  redirectUrlInternalUser: "https://fcs-dnbus.cs9.force.com/support/?Origin=DIVR",
  ipUrl: "https://ipapi.co/json/",
  driftAccount: "rdvdcsf9mkra",
  driftPlaybook: 271453,
  driftCaseOrigin: "Chat (Digital IVR)",
  loginFailureScenario: "https://fcs-dnbus.cs9.force.com/support/?prod=sso&origin=divr",
  domain: "dev-service.dnb.com",
  googleMeasurementId: "G-EY52611TBT",
  title: "Digital Service Center: support for all things Dun & Bradstreet",
  metaDescription: 'Customer service portal for D&B solutions/services. Request a D-U-N-S Number, update your company information, get product help, access live support options.'
  },
  "uk" : {
    hmr: true,
    enableMock: false, // true for mock; else false
    useProxy: false, // true for mock; else false
    mockUrl: "http://localhost:3000",
    apiUrl: "https://i1uipzq935.execute-api.eu-north-1.amazonaws.com/divr-dev", // API URL - DNB Dev
    // https://i1uipzq935.execute-api.eu-north-1.amazonaws.com/divr-dev/ivr/getEnglishChannelMap?userType=Business
    // apiUrl: "https://m2ydq5e7ch.execute-api.us-east-1.amazonaws.com/divr-dev", // API URL - CTS Dev
    oktaUrl: "https://qa.sso.dnb.com/oauth2/ausg86rerPKZ500yO1d6/v1", // Okta URL - QA
    oktaClientId: "0oahk097iVUKMc7kX1d6", // Okta client ID - QA
    version: "<<VERSION>>",
    googleAnalyticsKey:"",
    redirectUrlInternalUser: "https://fcs-dnbus.cs9.force.com/support/?Origin=DIVR",
    ipUrl: "https://ipapi.co/json/",
    driftAccount: "tt96hwidbxxb",
    // driftPlaybook: 389219,
    swedishDriftPlaybook: 396137,
    swedishEnglishDriftPlaybook: 390363,
    driftCaseOrigin: "Chat (Digital IVR)",
    loginFailureScenario: "https://fcs-dnbus.cs9.force.com/support/?prod=sso&origin=divr",
    cgClientId: '7189sbl23q514ilj581ot2c6co', //Customer Gauge Client-Id
    cgClientSecret: '6fasnl06884o2r17cvdbnvqtukp8hc51cfd7pc1jijpnlsu1s0h', //Customer Gauge Client-Secret
    cgTokenUrl: 'https://auth.eu.customergauge.com/oauth2/token',
    cgFeedbackUrl: 'https://imports.api.eu.customergauge.com',
    cgEmail: "dev-divrtechsupport@dnb.com",
    title: "UK Digital Service Center: support for all things Dun & Bradstreet",
    metaDescription: 'UK Customer service portal for D&B solutions/services. Request a D-U-N-S Number, update your company information, get product help, access live support options.'
    },

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
